// extracted by mini-css-extract-plugin
export default {"fullContainer":"styles_fullContainer__A5dyt","title":"styles_title__wfP3t","artistsList":"styles_artistsList__rup7m","artist":"styles_artist__+m3VT"};